import styled from "styled-components";

export const CircleMenu = styled.div``;

export const MenuContainerMobile = styled.div`
  /* width: 50px; */
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .number-circle {
    position: absolute;
    top: -6px;
    right: -14px;
    width: 28px;
    height: 28px;
    background-color: var(--color-primary);
    border-radius: 90%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    padding: 4px;
  }
`;

export const HeaderBarMainContainer = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 44px;
  background: var(--color-primary-gradient);
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14);

  @media (max-width: 1279px) {
    height: 75px;
    padding: 0 18px;
    transition: all 0.5s;
  }

  @media (max-width: 1279px) {
    ${({ $isIos }) =>
    $isIos === true
      ? `padding-top: 45px;
              height: 90px;
             `
      : `height: 75px;
      padding: 0 18px; `};
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
`;
